import { connect } from 'react-redux'
import FlagsSplashScreen from '../components/FlagSplashScreen/FlagsSplashScreen.jsx'

const mapStateToProps = state => ({
    
})

export default connect(mapStateToProps)(FlagsSplashScreen)
